export default __webpack_public_path__ + "static/media/xp_boost_icon.a3be5a4f.riv";